module.exports = __webpack_public_path__ + "img/frasco_cili_1000.4b28bdc2.png";